import React, { useState, KeyboardEvent } from "react";
import axios from "axios";
import styles from "./css/Login.module.css";

interface LoginProps {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setLoginId: React.Dispatch<React.SetStateAction<number>>;
}

interface LoginDto {
  apiKey: string;
}

export default function Login({ setPage, setLoginId }: LoginProps) {
  const [apiKey, setApiKey] = useState(
    () => localStorage.getItem("apiKey") || ""
  );

  const handleLogin = async () => {
    if (apiKey === "") {
      alert("API Key를 입력하세요.");
      return;
    }

    const loginDto: LoginDto = {
      apiKey: apiKey,
    };

    try {
      const response = await axios.post(`/api/login`, loginDto);
      if (response.status === 200 || response.status === 201) {
        const id = response.data.data;
        localStorage.setItem("apiKey", apiKey);
        sessionStorage.setItem("id", id);

        setLoginId(id);
        setPage(1);
      }
    } catch (error: any) {
      alert(error.response.data.message);
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>쌈무톡</h1>
      <input
        id="apiKey"
        type="text"
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="API Key를 입력하세요."
        className={styles.input}
      />
      <button onClick={handleLogin} className={styles.button}>
        로그인
      </button>
      <p className={styles.guide}>
        <a
          href="https://boom-dead-1ee.notion.site/NEXON-Open-API-Key-134ba2b7e4b580cabdcad048f38c16c4?pvs=74"
          target="_black"
        >
          API Key 발급받기
        </a>
      </p>
    </div>
  );
}
